import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Segment, Form, Label, Input, Dropdown} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {toUpperCase} from '../../../common/util/fieldsNormalization';
import {partClassification} from '../../../common/dictionaries/classification';
import {tabKeyCode, enterKeyCode} from '../../../common/constants/keyCodes';
import FinancialInfo from './financial';
import ChangeFranchiseModal from '../modals/changeFranchise';

const parseClassification = () => {
  const keys = Object.keys(partClassification);
  return keys.map((key) => ({'text': partClassification[key], 'value': key, 'key': key}));
};

class BasicInfo extends Component {
  parseSuppliers = () => {
    const {suppliers} = this.props;
    return suppliers.map((supplier) => ({'text': supplier.name, 'value': supplier.code}));
  }

  parseScc = () => {
    const {partsScc} = this.props;
    return partsScc.map((scc) => ({'text': scc.code, 'value': scc.code}));
  }

  loadPartInfo = (event) => {
    const {partCode} = this.props;
    
    if (partCode && (event.keyCode === tabKeyCode || event.keyCode === enterKeyCode)) {
      event.preventDefault();
      event.stopPropagation();
      this.props.restorePartsFormValues();
      this.props.getPartMasterInfo(partCode);
      this.props.getPartRejectionInfo(partCode);
      this.props.getPartSubstitutes(partCode);
      this.props.getPartSpecialSubstitutes(partCode);
      this.props.getPartEquivalences(partCode);
      this.props.getPartCarCompatibility(partCode);
      this.props.fetchPartAttachments(partCode);
    }
  }

  handleChange = (event, data) => {
    const {name, value} = data;
    this.props.changePartsFormValue(name, toUpperCase(value));

    if (name === 'partCode') {
      this.props.setPartAttachments([]);
    }
  }

  handleSupplierChange = (event, data) => {
    const {suppliers} = this.props;
    const selected = suppliers.find((supplier) => supplier.code === data.value);
    const origin = selected ? selected.origin : '';

    this.props.changePartsFormValue(data.name, data.value);
    this.props.changePartsFormValue('origin', origin);
  }

  handleProductCodeLossFocus = (event) => {
    const {value} = event.target;

    if (value && !this.props.isGrey) {
      this.props.getProductCodePriceFactors(value);

      if (this.props.company) {
        this.props.addMessageBoxWarning('Recuerde actualizar los factores de precio.');
      }
    }
  }

  renderPncLink = () => {
    const {pncLink} = this.props;

    if (pncLink) {
      return (<a className='pnc-error-link' href={pncLink} target='_blank' rel="noreferrer">Registrar PNC</a>);
    }
    
    return null;
  }

  render() {
    const {franchise, productCode, pnc, icc, scc, partClass, partCode, partName, supplier, origin,
      loadingSuppliers, rejectionCode, pncDescription, company, obs, gallon} = this.props;
    const filledFields = franchise && productCode && pnc && partCode && partName && supplier && origin;
      
    return (
      <React.Fragment>
        <Segment secondary>
          <Form.Group>
            <Form.Field className='franchise-field' width='1'>
              <label>
                <strong>Franquicia</strong>
              </label>
              <Input
                fluid
                required
                name='franchise'
                maxLength='2'
                value={franchise}
                onChange={this.handleChange}
                icon
                iconPosition='right'
              >
                <input />
                {!filledFields ? null : (
                  <ChangeFranchiseModal partCode={partCode} company={company} />
                )}
              </Input>
            </Form.Field>
            <Form.Field width='3'>
              <label>
                <strong>Código</strong>
              </label>
              <Input
                fluid
                required
                name='partCode'
                maxLength='20'
                value={partCode}
                onChange={this.handleChange}
                onKeyDown={this.loadPartInfo}
              />
            </Form.Field>
            <Form.Field width='6'>
              <label>
                <strong>Descripción</strong>
              </label>
              <Input
                fluid
                required
                name='partName'
                maxLength='50'
                value={partName}
                onChange={this.handleChange}
              />
            </Form.Field>
            <Form.Field width='4'>
              <label>
                <strong>Proveedor</strong>
              </label>
              <Dropdown
                fluid
                selection
                search
                name='supplier'
                options={this.parseSuppliers()}
                value={supplier}
                error={!supplier}
                onChange={this.handleSupplierChange}
                loading={loadingSuppliers}
                disabled={loadingSuppliers}
                noResultsMessage='No se encontraron resultados'
              />
            </Form.Field>
            <Form.Field width='2'>
              <label>
                <strong>Origen</strong>
              </label>
              <Label size='large'>{origin}</Label>
            </Form.Field>
            <Form.Field width='2'>
              <label>
                <strong>Obsolescencia</strong>
              </label>
              <Label size='large'>{obs}</Label>
            </Form.Field>
          </Form.Group>
        </Segment>
        <FinancialInfo />
        <Segment secondary>
          <Form.Group>
            <Form.Select
              width='2'
              fluid
              search
              label='Clasificación'
              name='partClass'
              options={parseClassification()}
              value={partClass}
              disabled={company !== null}
              onChange={this.handleChange}
            />
            <Form.Field width='2'>
              <label><strong>Galones</strong></label>
              <Input fluid required
                min='0.00'
                type='number'
                step='any'
                name='gallon'
                value={gallon}
                onChange={this.handleChange}
              />
            </Form.Field>
            <Form.Input width='1' fluid readOnly label='ICC' value={icc} />
            <Form.Select
              width='1'
              fluid
              name='scc'
              disabled={!company}
              label='SCC'
              value={scc}
              options={this.parseScc()}
              onChange={this.handleChange}
            />
            <Form.Field width='2'>
              <label>
                <strong>Product Code</strong>
              </label>
              <Input
                fluid
                required
                name='productCode'
                maxLength='4'
                value={productCode}
                onChange={this.handleChange}
                onBlur={this.handleProductCodeLossFocus}
              />
            </Form.Field>
            <Form.Field width='2'>
              <label>
                <strong>PNC</strong>
                {this.renderPncLink()}
              </label>
              <Input
                fluid
                required
                name='pnc'
                maxLength='7'
                value={pnc}
                onChange={this.handleChange}
              />
            </Form.Field>
            <Form.Field width='5'>
              <label>
                <strong>Descripción PNC</strong>
              </label>
              <Input readOnly fluid maxLength='7' value={pncDescription} />
            </Form.Field>
            <Form.Field width='3'>
              <label>
                <strong>Reject</strong>
              </label>
              <Label size='large'>{rejectionCode}</Label>
            </Form.Field>
          </Form.Group>
        </Segment>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const {values, factors, rejectionCode, pncLink, partsScc, attachments, rawAttachments} = state.partsMaster || {};
  const {pncDescription, franchise, productCode, pnc, icc, scc, partClass, partCode, partName,
    supplier, origin, isGrey, company, obs, gallon} = values || {};

  return {
    'loadingSuppliers': state.provider.loading,
    'suppliers': state.provider.list,
    partsScc,
    pncDescription,
    franchise,
    productCode,
    pnc,
    pncLink,
    attachments,
    rawAttachments,
    rejectionCode,
    factors,
    icc,
    scc,
    partClass,
    partCode,
    partName,
    supplier,
    origin,
    isGrey,
    company,
    obs,
    gallon,
  };
};

const {
  setPartAttachments,
  changePartsFormValue,
  getPartMasterInfo,
  getPartPriceFactors,
  getPartSubstitutes,
  getPartSpecialSubstitutes,
  getPartEquivalences,
  getPartCarCompatibility,
  restorePartsFormValues,
  getPartRejectionInfo,
  getProductCodePriceFactors,
  addMessageBoxWarning,
  fetchPartAttachments,
} = Actions;

export default connect(mapStateToProps, {
  setPartAttachments,
  changePartsFormValue,
  getPartMasterInfo,
  getPartPriceFactors,
  getPartSubstitutes,
  getPartSpecialSubstitutes,
  getPartEquivalences,
  getPartCarCompatibility,
  restorePartsFormValues,
  getPartRejectionInfo,
  getProductCodePriceFactors,
  addMessageBoxWarning,
  fetchPartAttachments,
})(BasicInfo);
